import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { fontFamily, space, textStyle } from "@passfirst/ui";

import { type Colors, useColors } from "../../theme";

interface Props {
  topicLabel: string;
  stem: string;
  /** Larger serif stem for the web split-pane layout (Rule A, ≥900). */
  large?: boolean;
}

// Mono-uppercase topic eyebrow + Newsreader-serif stem. The serif is
// the only place serif appears in the app — signals "content, not
// chrome" per the 2026 design refresh. Stem is centered horizontally
// via parent layout, not by this component.
export function TopicStem({ topicLabel, stem, large = false }: Props): JSX.Element {
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <View>
      <Text style={styles.eyebrow}>{topicLabel.toUpperCase()}</Text>
      <Text style={[styles.stem, large && styles.stemLarge]}>{stem}</Text>
    </View>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
    eyebrow: {
      fontFamily: fontFamily.monoMedium,
      fontSize: 11,
      letterSpacing: 1.2,
      color: colors.textMuted,
      marginTop: space[5],
      marginBottom: space[3],
    },
    stem: {
      ...textStyle.questionStem,
      color: colors.textPrimary,
      marginBottom: space[4],
    },
    // Split-pane stem grows to 27/1.4 per design_handoff_2 (Rule A).
    stemLarge: { fontSize: 27, lineHeight: 38 },
  });
}
